"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var BytesConverter = /** @class */ (function () {
    function BytesConverter() {
    }
    BytesConverter.instance = function () {
        if (!BytesConverter._instance) {
            BytesConverter._instance = new BytesConverter();
        }
        return BytesConverter._instance;
    };
    BytesConverter.prototype.decode = function (body) {
        return body;
    };
    BytesConverter.prototype.encode = function (value) {
        return value;
    };
    return BytesConverter;
}());
exports.BytesConverter = BytesConverter;
